<template>
  <div class="select-box-wrapper">
      <div class="select-box-title">{{item.title}}:</div>
      <dx-select-box
        :data-source="dataSource"
        :value.sync="selectedValue"
        :search-enabled="true"
        placeholder="Velg..."
        @value-changed="onValueChanged($event)"
      />
  </div>
</template>

<script>

  import DxSelectBox from 'devextreme-vue/select-box'
  import DataSource from 'devextreme/data/data_source';

  function getDataSource(data) {
    data = data || [];

    return new DataSource({
      store: data,
      sort: function (value) {
        return value;
      }
    });
  }

  export default {
    name: 'ElhubSelectBox',
    data () {
      return {
        dataSource: null
      }
    },
    props: ['item'],
    components: {
      DxSelectBox
    },
    computed: {
      selectedValue: {
        get: function () {
          return this.item.value;
        },
        set: function (data) {
          this.item.value = data;
        }
      }
    },
    created () {
      this.dataSource = getDataSource(this.item.data);
    },
    methods: {
      onValueChanged(event) {
        this.$emit('value-change', { id: this.item.id, value: event.value } );
      }
    }
  }
</script>

<style scoped>

  .select-box-title {
    font-size:   14px;
    font-weight: 600;
    padding:     6px 0;
  }

  .select-box-wrapper {
    max-width:    300px;
    display:      inline-block;
    margin-right: 20px;
  }
</style>
